import mutations from './mutations'
import actions from './actions'

const state = {
    isFetching: false,
    error: null,
    premise: null,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
